{
  "name": "neo-gallery",
  "version": "1.1.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.0",
    "@angular/cdk": "^20.2.2",
    "@angular/cli": "^20.3.1",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/compiler-cli": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/material": "^20.2.2",
    "@angular/platform-browser": "^20.3.0",
    "@angular/platform-browser-dynamic": "^20.3.0",
    "@angular/router": "^20.3.0",
    "rxjs": "~7.8.2",
    "uuid": "^11.1.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.0",
    "@types/jasmine": "~5.1.7",
    "@types/uuid": "^10.0.0",
    "typescript": "5.8.3"
  }
}